export const aboutInfo = {
  brandName: '黄油网页游戏合集',
  tagline: '免费在线畅玩黄油网页游戏合集',
  description: '黄油网页游戏合集是国内领先的免费在线游戏平台，致力于为广大玩家提供最新最全的黄油网页游戏资源。无需下载安装，打开浏览器即可畅玩数百款精选黄油网页游戏。',
  story: '黄油网页游戏合集创立于2024年，创始团队由一群热爱黄油网页游戏的资深玩家组成。我们发现市面上的黄油网页游戏虽然数量众多，但缺乏一个专业、全面的聚合平台。于是我们创建了黄油网页游戏合集，希望通过精心的筛选和分类，帮助玩家快速找到心仪的黄油网页游戏。经过两年的发展，黄油网页游戏合集已经成为国内最受欢迎的黄油网页游戏导航平台之一，累计服务超过500万玩家。',
  stats: [
    { label: '收录游戏', value: '500+' },
    { label: '日均玩家', value: '120万+' },
    { label: '游戏分类', value: '8大类' },
    { label: '运营年限', value: '2年+' },
  ],
  values: [
    { title: '精选品质', description: '每一款黄油网页游戏都经过团队严格筛选和深度评测，确保推荐给玩家的都是高品质黄油网页游戏。' },
    { title: '免费畅玩', description: '黄油网页游戏合集上的所有黄油网页游戏均完全免费，无需任何付费即可畅享完整游戏体验。' },
    { title: '持续更新', description: '我们的编辑团队每日更新黄油网页游戏资源，确保玩家始终能体验到最新最热的黄油网页游戏。' },
    { title: '玩家至上', description: '黄油网页游戏合集始终以玩家体验为核心，不断优化平台功能和黄油网页游戏推荐算法。' },
  ],
  testimonials: [
    { name: '游戏达人阿杰', role: '资深玩家', content: '黄油网页游戏合集是我每天必逛的网站，分类清晰、更新及时，帮我找到了好多好玩的黄油网页游戏！' },
    { name: '小白玩家小美', role: '休闲玩家', content: '作为一个黄油网页游戏新手，黄油网页游戏合集的入门指南对我帮助太大了，推荐给了好多朋友。' },
    { name: '老玩家大明', role: '十年游龄', content: '用过很多黄油网页游戏导航站，黄油网页游戏合集是做得最好的，游戏质量高，没有乱七八糟的广告。' },
  ],
  contact: {
    email: 'contact@butterwebgames.com',
    wechat: 'butterwebgames',
    qq: '1234567890',
    address: '广东省广州市天河区体育西路111号',
  },
};

export const faqItems = [
  {
    question: '黄油网页游戏需要下载吗？',
    answer: '不需要！黄油网页游戏的最大特色就是无需下载安装，直接在浏览器中打开即可畅玩。只需确保浏览器为最新版本（推荐Chrome或Edge），就能获得最佳的黄油网页游戏体验。',
  },
  {
    question: '黄油网页游戏需要付费吗？',
    answer: '黄油网页游戏合集上推荐的所有黄油网页游戏均为免费游戏。部分黄油网页游戏内可能包含可选的内购项目，但所有核心玩法都是免费开放的，不花钱也能完整体验黄油网页游戏。',
  },
  {
    question: '手机可以玩黄油网页游戏吗？',
    answer: '可以！现代黄油网页游戏大多基于HTML5技术开发，完美适配移动端浏览器。你可以在手机、平板等设备上随时随地畅玩黄油网页游戏，而且账号数据多端同步。',
  },
  {
    question: '黄油网页游戏有哪些热门类型？',
    answer: '黄油网页游戏类型丰富多样，热门类型包括角色扮演(RPG)、策略战棋、冒险解谜、模拟经营、动作格斗、休闲益智、卡牌对战和多人联机(MMO)等八大类。每种类型的黄油网页游戏都有各自独特的魅力和玩法。',
  },
  {
    question: '如何选择适合自己的黄油网页游戏？',
    answer: '建议从以下几个方面考虑：首先确定你喜欢的黄油网页游戏类型（如喜欢故事选RPG，喜欢动脑选策略）；其次参考黄油网页游戏排行榜和玩家评分；最后可以阅读我们的黄油网页游戏评测文章，了解游戏详情后再做选择。',
  },
  {
    question: '黄油网页游戏需要注册账号吗？',
    answer: '大部分黄油网页游戏提供游客模式，可以直接开始游玩。但如果想要保存进度、参与社交功能或跨设备同步数据，建议注册一个黄油网页游戏账号，通常只需邮箱即可快速注册。',
  },
  {
    question: '黄油网页游戏对电脑配置要求高吗？',
    answer: '不高。黄油网页游戏在浏览器中运行，对硬件配置的要求远低于客户端游戏。只要你的电脑能流畅浏览网页，就能畅玩绝大多数黄油网页游戏。',
  },
];